import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-admin-dashboard',
  template: `
    <div class="admin-landing">
      <h2>Admin Dashboard</h2>
      <div class="dashboard-grid">
        <div class="dashboard-card" routerLink="/admin/users">
          <mat-icon>people</mat-icon>
          <h3>User Management</h3>
          <p>View and manage registered users</p>
        </div>
        <div class="dashboard-card" routerLink="/admin/chapters">
          <mat-icon>auto_stories</mat-icon>
          <h3>Curriculum Management</h3>
          <p>Configure Subjects, Books, Lessons, Flashcards, and Quizzes</p>
        </div>
        <div class="dashboard-card" routerLink="/middle-school-math">
          <mat-icon>school</mat-icon>
          <h3>Middle School Math Player</h3>
          <p>Access lessons, flashcards, and quizzes</p>
        </div>
        <!-- Placeholder for future admin modules -->
        <div class="dashboard-card disabled">
          <mat-icon>analytics</mat-icon>
          <h3>Analytics</h3>
          <p>Coming Soon</p>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .admin-landing { padding: 2rem; }
    .dashboard-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(250px, 1fr)); gap: 2rem; margin-top: 2rem; }
    .dashboard-card {
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      padding: 2rem;
      text-align: center;
      cursor: pointer;
      transition: all 0.3s ease;
      background: white;
    }
    .dashboard-card:hover:not(.disabled) {
      transform: translateY(-5px);
      box-shadow: 0 4px 12px rgba(0,0,0,0.1);
      border-color: #ffd740;
    }
    .dashboard-card mat-icon { font-size: 48px; height: 48px; width: 48px; margin-bottom: 1rem; color: #ffd740; }
    .dashboard-card.disabled { opacity: 0.6; cursor: default; }
    .dashboard-card.disabled mat-icon { color: #bdbdbd; }
  `],
  standalone: true,
  imports: [CommonModule, MatIconModule, RouterModule]
})
export class AdminDashboardComponent { }
